import { render, staticRenderFns } from "./TotalsModal.vue?vue&type=template&id=ff312f6a&scoped=true&"
import script from "./TotalsModal.vue?vue&type=script&lang=js&"
export * from "./TotalsModal.vue?vue&type=script&lang=js&"
import style0 from "./TotalsModal.vue?vue&type=style&index=0&id=ff312f6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff312f6a",
  null
  
)

component.options.__file = "TotalsModal.vue"
export default component.exports